@if (loading()) {
  <span class="loading loading-spinner loading-md text-primary-purple self-center"></span>
} @else {
  <app-detail-form [fields]="fields()" [edit]="edit()" (fieldChange)="draft.change($event)" />
  @if (edit()) {
    <app-form-actions class="block pt-4" [saveDisabled]="!isValid() || saving()" (cancelAction)="cancel()" (saveAction)="save()" />
  }
}
